import actions from './actions';

export default {
  namespaced: true,
  actions,
};



// WEBPACK FOOTER //
// ./src/store/lad/index.js